import * as yup from 'yup'
import { CreateExamSurveyUserAnswerInput } from 'generated/graphql'
import SUBJECT_MAX_QUESTION_COUNT from '@app.feature/exam/gsat2024-2/constants/subjectMaxQuestionCount'

export const EXAM_SURVEY_FORM_DEFAULT_VALUE: ExamSurveyFormFields = {
  choiceOneQuestions: {
    question1: {
      answerId: '',
      questionId: '',
    },
    question2: {
      answerId: '',
      questionId: '',
    },
    question3: {
      answerId: '',
      questionId: '',
    },
    question4: {
      answerId: '',
      questionId: '',
    },
    question5: {
      answerId: '',
      questionId: '',
    },
    question7: {
      answerId: '',
      questionId: '',
    },
  },
  inputQuestions: {
    question6: {
      suri: {
        answerId: '',
        questionId: '',
        numericAnswer: null,
      },
      churi: {
        answerId: '',
        questionId: '',
        numericAnswer: null,
      },
    },
  },
}

export interface ExamSurveyFormFields {
  choiceOneQuestions: {
    question1: CreateExamSurveyUserAnswerInput
    question2: CreateExamSurveyUserAnswerInput
    question3: CreateExamSurveyUserAnswerInput
    question4: CreateExamSurveyUserAnswerInput
    question5: CreateExamSurveyUserAnswerInput
    question7: CreateExamSurveyUserAnswerInput
  }
  inputQuestions: {
    question6: Question6Type
  }
}

export interface Question6Type {
  suri: CreateExamSurveyUserAnswerInput
  churi: CreateExamSurveyUserAnswerInput
}

const createExamSurveyUserAnswerInputValitate = yup.object({
  answerId: yup.string().required(),
  questionId: yup.string().required(),
  numericAnswer: yup.number(),
})

export const examSurveySchema = yup.object({
  choiceOneQuestions: yup.object({
    question1: createExamSurveyUserAnswerInputValitate,
    question2: createExamSurveyUserAnswerInputValitate,
    question3: createExamSurveyUserAnswerInputValitate,
    question4: createExamSurveyUserAnswerInputValitate,
    question5: createExamSurveyUserAnswerInputValitate,
    question7: createExamSurveyUserAnswerInputValitate,
  }),
  inputQuestions: yup.object({
    question6: yup.object({
      suri: createExamSurveyUserAnswerInputValitate.shape({
        numericAnswer: yup.number().max(SUBJECT_MAX_QUESTION_COUNT.suri),
      }),
      churi: createExamSurveyUserAnswerInputValitate.shape({
        numericAnswer: yup.number().max(SUBJECT_MAX_QUESTION_COUNT.churi),
      }),
    }),
  }),
})
